/**
 * Canais oficiais de contato, como definidos nos documentos da Empiria.
 *
 * Cada endereço tem uma operação própria, e é o documento que a define -- não
 * dá para trocar um pelo outro. Ficam reunidos aqui para que a tela certa use
 * o endereço certo, e para que uma mudança futura seja um lugar só.
 *
 *   suporte    - Termos 12.9 e Compra e Pagamento I
 *   reembolso  - Compra e Pagamento 3.4.1, único canal válido para pedir
 *                reembolso, junto com o chat da Plataforma
 *   denuncias  - Termos 12.1, junto com o chat da Plataforma
 *   dpo        - Encarregado de Dados, Cookies e Privacidade F, 9 e 12
 *   seguranca  - Politica de Seguranca Cibernetica 5.2, para o publico externo
 *                comunicar falha ou inconsistencia no ambiente da Empiria
 *
 * ATENÇÃO: em 20/08/2026 nenhuma dessas caixas existia ainda. A criação está
 * cobrada em PENDENCIAS_COM_O_CLIENTE.txt, na raiz do projeto.
 */
export const CONTATOS = {
    suporte: 'suporte@empiriapp.com.br',
    reembolso: 'reembolso@empiriapp.com.br',
    denuncias: 'denuncias@empiriapp.com.br',
    dpo: 'dpo@empiriapp.com.br',
    seguranca: 'seguranca@empiriapp.com.br',
};

export default CONTATOS;
